import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer-dots',
  templateUrl: './footer-dots.component.html',
  styleUrls: ['./footer-dots.component.scss']
})
export class FooterDotsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
